<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Dashboard</h1>
        </div>
        <h2 class="page_title text-center">Welcome Admin !</h2>
        <form [formGroup]="form">
            <div class="content-section dashboard-block">
                <ul class="dash_list d-flex m-auto flex-wrap text-center">
                    <li routerLink="/therapist" class="theme" style="cursor:pointer">
                        <div class="dash_icon">
                            <i class="fa fa-user-md" aria-hidden="true"></i>
                            <!-- <i class="fa fa-users" aria-hidden="true"></i> -->
                        </div>
                        <h2>Therapists</h2>
                        <h4>{{data?.therapists}}</h4>
                    </li>
                    <li class="theme" routerLink="/patient-mgt" style="cursor:pointer">
                        <div class="dash_icon">
                            <i class="fa fa-hospital-o" aria-hidden="true"></i>
                        </div>
                        <h2>Patients</h2>
                        <h4>{{data?.patients}}</h4>
                    </li>
                    <li class="theme" routerLink="/program-mgt" style="cursor:pointer">
                        <div class="dash_icon">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                        <h2>Programs</h2>
                        <h4>{{data?.programs}}</h4>
                    </li>
                    <h4 class="mt-3 pl-2">
                        You can do following things direct from here-
                    </h4>
                    <ul class="dash_list d-flex  flex-wrap text-center">
                        <li style="cursor:pointer">
                            <div class="d-flex padding_5" routerLink="/add-subadmin">
                                <i class="dash_icon1 me-2 fa fa-plus" aria-hidden="true"></i>
                                <label>Add Subadmin</label>
                            </div>

                        </li>
                        <li style="cursor:pointer">
                            <div class="d-flex padding_5" routerLink="/add-patient">
                                <i class="dash_icon1 me-2 fa fa-plus" aria-hidden="true"></i>
                                <label>Add Patient</label>
                            </div>

                        </li>
                        <li style="cursor:pointer">
                            <div class="d-flex padding_5" routerLink="/add-therapist">
                                <i class="dash_icon1 me-2 fa fa-plus" aria-hidden="true"></i>
                                <label>Add Therapists</label>
                            </div>
                        </li>
                    </ul>
                    <ul class="dash_list d-flex  flex-wrap text-center">
                        <li style="cursor:pointer">
                            <div class="d-flex padding_5" routerLink="/add-therapist">
                                <i class="dash_icon1 me-2 fa fa-plus " aria-hidden="true"></i>
                                <label>Add Medical</label>
                            </div>

                        </li>
                        <li style="cursor:pointer">
                            <div class="d-flex padding_5" routerLink="/add-program">
                                <i class="dash_icon1 me-2 fa fa-plus" aria-hidden="true"></i>
                                <label>Add Program</label>
                            </div>

                        </li>
                        <li style="cursor:pointer">
                            <div class="d-flex padding_5" routerLink="/notification">
                                <i class="dash_icon1 me-2 fa fa-plus" aria-hidden="true"></i>
                                <label>Send Notification</label>
                            </div>

                        </li>
                    </ul>
                    <h4 class="mt-3 pl-2">
                        Generate report with following columns as per requirement-
                    </h4>
                    <div class="row pl-2 w-100">
                        <div class="col-md-3 mb-3 text-left">
                            <label for="">Select Patient : </label>
                            <select name="patient" [attr.disabled]="((form.controls.Medical.valid)
                         || (form.controls.Therapist.valid) || (form.controls.Program.valid)? '' : null)"
                                class="custom-select form-control" formControlName="Patient" id="inputGroupSelect01"
                                aria-labelledby="dropdownMenuButton" id="">
                                <option value="">Select Patient</option>
                                <option value="Patient">All</option>
                            </select>
                        </div>
                        <div class="col-md-3 mb-3 text-left">
                            <label for="">Select Medical : </label>
                            <select name="" class="form-control custom-select" formControlName="Medical"
                                [attr.disabled]="((form.controls.Patient.valid)
                        || (form.controls.Therapist.valid) || (form.controls.Program.valid)? '' : null)">
                                <option value="">Select Medical</option>
                                <option value="Medical">All</option>
                            </select>
                        </div>
                        <div class="col-md-3 mb-3 text-left">
                            <label for="">Select Therapist : </label>
                            <select name="" class="form-control custom-select" formControlName="Therapist"
                                [attr.disabled]="((form.controls.Patient.valid)
                        || (form.controls.Medical.valid) || (form.controls.Program.valid)? '' : null)">
                                <option value="">Select Therapist</option>
                                <option value="Therapist">All</option>
                            </select>
                        </div>
                        <div class="col-md-3 mb-3 text-left">
                            <label for="">Select Program : </label>
                            <select name="" class="form-control custom-select" [attr.disabled]="((form.controls.Patient.valid)
                        || (form.controls.Medical.valid) || (form.controls.Therapist.valid)? '' : null)"
                                formControlName="Program">
                                <option value="">Select Program</option>
                                <option value="Program">All</option>
                            </select>
                        </div>
                        <div class="col-md-3 mb-3 text-left">
                            <mat-form-field appearance="fill" class="w-100">
                                <mat-label>Select Range From :</mat-label>
                                <input matInput [max]="maxDate" [matDatepicker]="picker" formControlName="fromDate">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                            <!-- <input type="date" formControlName="fromDate" placeholder="yyyy-mm-dd" name="" class="form-control" id="fromDate"> -->
                        </div>
                        <div class="col-md-3 mb-3 text-left">
                            <mat-form-field appearance="fill" class="w-100">
                                <mat-label>Select Range To :</mat-label>
                                <input matInput [max]="maxDate" [matDatepicker]="picker1" formControlName="toDate">
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                            <!-- <input type="date" placeholder="yyyy-mm-dd" formControlName="toDate" name="" class="form-control" id="toDate"> -->
                        </div>
                        <div class="col-md-12 text-center mb90">
                            <button class="btn btn-theme col-md-4 " (click)="generateReport()">
                                Generate Report
                            </button>
                        </div>

                    </div>

                </ul>

            </div>
        </form>
    </main>
</div>